import React, { useState } from 'react';
import './FAQ.css';
import SectionCTA from './SectionCTA';

const faqs = [
  {
    q: 'How can AI automation help my business?',
    a: 'AI automation eliminates repetitive manual tasks, speeds up workflows, reduces human error, and frees your team to focus on high-value work. From data entry to customer communication, AI handles routine operations so your business runs more efficiently.',
  },
  {
    q: 'Is AI automation difficult to integrate?',
    a: 'Not at all. Our team manages the entire integration process—from auditing your current systems to deploying and testing the solution. We ensure minimal disruption to your existing workflows and provide full support throughout.',
  },
  {
    q: 'What industries can benefit from AI automation?',
    a: 'AI automation benefits virtually every industry—finance, healthcare, e-commerce, logistics, real estate, marketing agencies, SaaS companies, and more. If your business has repetitive processes, AI can optimize them.',
  },
  {
    q: 'Do I need technical knowledge to use AI automation?',
    a: 'No technical background is required. We handle all the technical complexity on your behalf. Our solutions are designed to be user-friendly, and we provide training and documentation so your team can work with confidence.',
  },
  {
    q: 'What kind of support do you offer?',
    a: 'We offer end-to-end support including initial consultation, system design, development, integration, and ongoing optimization. After deployment, we monitor performance and continuously improve your automation systems.',
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(null);

  return (
    <section className="faq" id="faq">
      <div className="faq-inner">
        <div className="faq-header">
          <span className="section-label">FAQ</span>
          <h2 className="section-title">We've Got the Answers<br />You're Looking For</h2>
          <p className="faq-sub">Quick answers to your AI automation questions.</p>
        </div>
        <div className="faq-list">
          {faqs.map((f, i) => (
            <div key={i} className={`faq-item ${open === i ? 'open' : ''}`} onClick={() => setOpen(open === i ? null : i)}>
              <div className="faq-question">
                <span>{f.q}</span>
                <span className="faq-icon">{open === i ? '−' : '+'}</span>
              </div>
              {open === i && (
                <div className="faq-answer">{f.a}</div>
              )}
            </div>
          ))}
        </div>
        <SectionCTA label="Still deciding between email and a call?" />
      </div>
    </section>
  );
}
